import { formatInLao } from "@/shared/lib/date-time";
import { addMonths, parse, subDays } from "date-fns";

export type StackedPackagePeriod = {
  periodIndex: number;
  startDate: string;
  expireDate: string;
};

/**
 * คำนวณช่วงวันต่อกันสำหรับ stacked package purchase
 * 1 รอบ = 1 เดือนปฏิทิน (validDays ของ template ไม่กำหนดความยาวรอบเมื่อซื้อหลายรอบ)
 * รอบ i: start = firstStartDate + (i-1) เดือน, expire = วันก่อน start รอบถัดไป
 */
export function computeStackedPackagePeriods(input: {
  firstStartDate: string;
  /** kept for call-site compatibility; not used for period length when quantity > 1 */
  validDays: number;
  quantity: number;
}): StackedPackagePeriod[] {
  const { firstStartDate, quantity } = input;
  const anchor = parse(firstStartDate, "yyyy-MM-dd", new Date());
  const periods: StackedPackagePeriod[] = [];

  for (let i = 1; i <= quantity; i++) {
    const startDateObj = addMonths(anchor, i - 1);
    const expireDateObj = subDays(addMonths(startDateObj, 1), 1);
    periods.push({
      periodIndex: i,
      startDate: formatInLao(startDateObj, "yyyy-MM-dd"),
      expireDate: formatInLao(expireDateObj, "yyyy-MM-dd"),
    });
  }

  return periods;
}
